import type { ReactElement } from "react"
import React from "react"
import TextWithTooltipMol from "@onestore/hel/dist/components/molecules/TextWithTooltipMol"
import type { TooltipMolProps } from "@onestore/hel/dist/components/molecules/TooltipMol"
import TooltipMol from "@onestore/hel/dist/components/molecules/TooltipMol"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import type { TooltipFlatData } from "@gatsby-plugin-generic-page/fragments/tooltip"
import isEmpty from "~/lib/isEmpty"
import type { SquidexMarkdownEmbeddedContent } from "~/types/squidex"

type TooltipProps = Omit<TooltipFlatData, "text"> &
  Omit<TooltipMolProps, "children"> & {
    children: string | SquidexMarkdownEmbeddedContent
  }

function Tooltip({
  children,
  labelText,
  labelTypography,
  isUnderlineTooltipLabel,
  ...restProps
}: TooltipProps): ReactElement<TooltipProps> | null {
  const tooltipElementText = (
    <MarkdownText typography={{ bold: "small3", default: "small2" }}>
      {children}
    </MarkdownText>
  )

  if (!isEmpty(labelText) && isUnderlineTooltipLabel) {
    return (
      <TextWithTooltipMol
        text={labelText}
        typography={labelTypography}
        tooltip={tooltipElementText}
      />
    )
  }

  return (
    <TooltipMol
      labelText={labelText}
      labelTypography={labelTypography}
      {...restProps}
    >
      {tooltipElementText}
    </TooltipMol>
  )
}

export default Tooltip
